import axios from 'axios';

// Production'da frontend ve backend aynı domain'de, preview'da farklı
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API_BASE = `${BACKEND_URL}/api`;

import { getValidToken } from '@/utils/tokenUtils';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

// Auth
export const login = async (username, password) => {
  const response = await axios.post(`${API_BASE}/auth/login`, { username, password });
  return response.data;
};

export const changePassword = async (currentPassword, newPassword) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/auth/change-password?token=${token}`, {
    current_password: currentPassword,
    new_password: newPassword
  });
  return response.data;
};

export const resetPassword = async (username, securityAnswer, newPassword) => {
  const response = await axios.post(`${API_BASE}/auth/reset-password`, {
    username,
    security_answer: securityAnswer,
    new_password: newPassword
  });
  return response.data;
};

// Users
export const getUsers = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/users?token=${token}`);
  return response.data;
};

export const createUser = async (userData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/users?token=${token}`, userData);
  return response.data;
};

export const deleteUser = async (userId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/users/${userId}?token=${token}`);
  return response.data;
};

export const updateUser = async (userId, userData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/users/${userId}?token=${token}`, userData);
  return response.data;
};

// Customers
export const getCustomers = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
  }
  const response = await axios.get(`${API_BASE}/customers?token=${token}`);
  return response.data;
};

export const getMyPortfolio = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
  }
  const response = await axios.get(`${API_BASE}/customers?token=${token}&my_portfolio=true`);
  return response.data;
};

export const getCustomer = async (customerId) => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
  }
  const response = await axios.get(`${API_BASE}/customers/${customerId}?token=${token}`);
  return response.data;
};

export const createCustomer = async (customerData) => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
  }
  const response = await axios.post(`${API_BASE}/customers?token=${token}`, customerData);
  return response.data;
};

export const updateCustomer = async (customerId, customerData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/customers/${customerId}?token=${token}`, customerData);
  return response.data;
};

export const deleteCustomer = async (customerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/customers/${customerId}?token=${token}`);
  return response.data;
};

export const deleteAllCustomers = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/customers?token=${token}`);
  return response.data;
};

// Prospects (Müşteri Adayları)
export const getProspects = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
  }
  const response = await axios.get(`${API_BASE}/prospects?token=${token}`);
  return response.data;
};

export const getProspect = async (prospectId) => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
  }
  const response = await axios.get(`${API_BASE}/prospects/${prospectId}?token=${token}`);
  return response.data;
};

export const createProspect = async (prospectData) => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Oturum süresi dolmuş. Lütfen tekrar giriş yapın.');
  }
  const response = await axios.post(`${API_BASE}/prospects?token=${token}`, prospectData);
  return response.data;
};

export const updateProspect = async (prospectId, prospectData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/prospects/${prospectId}?token=${token}`, prospectData);
  return response.data;
};

export const deleteProspect = async (prospectId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/prospects/${prospectId}?token=${token}`);
  return response.data;
};

export const convertProspectToCustomer = async (prospectId) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/prospects/${prospectId}/convert-to-customer?token=${token}`);
  return response.data;
};


export const uploadCustomerFile = async (customerId, file) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API_BASE}/customers/${customerId}/files?token=${token}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

export const deleteCustomerFile = async (customerId, fileId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/customers/${customerId}/files/${fileId}?token=${token}`);
  return response.data;
};

export const bulkImportCustomers = async (file) => {
  const token = getValidToken(); // Use safe token validation
  const formData = new FormData();
  formData.append('file', file);
  formData.append('token', token); // Add token as form field, not query param
  const response = await axios.post(`${API_BASE}/customers/bulk-import`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

// Visits
export const getVisits = async (days = null, representative = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/visits?token=${token}`;
  if (days) url += `&days=${days}`;
  if (representative) url += `&representative=${representative}`;
  const response = await axios.get(url);
  return response.data;
};

export const getCustomerVisits = async (customerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/customers/${customerId}/visits?token=${token}`);
  return response.data;
};

export const createVisit = async (visitData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/visits?token=${token}`, visitData);
  return response.data;
};

export const updateVisit = async (visitId, visitData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/visits/${visitId}?token=${token}`, visitData);
  return response.data;
};

export const deleteVisit = async (visitId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/visits/${visitId}?token=${token}`);
  return response.data;
};

// Sales
export const getSales = async (days = null, representative = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/sales?token=${token}`;
  if (days) url += `&days=${days}`;
  if (representative) url += `&representative=${representative}`;
  const response = await axios.get(url);
  return response.data;
};

export const getCustomerSales = async (customerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/customers/${customerId}/sales?token=${token}`);
  return response.data;
};


export const createSale = async (saleData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/sales?token=${token}`, saleData);
  return response.data;
};

export const updateSale = async (saleId, saleData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/sales/${saleId}?token=${token}`, saleData);
  return response.data;
};

export const deleteSale = async (saleId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/sales/${saleId}?token=${token}`);
  return response.data;
};

export const uploadSaleFile = async (saleId, file) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API_BASE}/sales/${saleId}/files?token=${token}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

// Calls
export const createCall = async (callData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/calls?token=${token}`, callData);
  return response.data;
};

export const getCalls = async (days = null, representative = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/calls?token=${token}`;
  if (days) url += `&days=${days}`;
  if (representative) url += `&representative=${representative}`;
  const response = await axios.get(url);
  return response.data;
};

export const getCustomerCalls = async (customerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/customers/${customerId}/calls?token=${token}`);
  return response.data;
};

export const updateCall = async (callId, callData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/calls/${callId}?token=${token}`, callData);
  return response.data;
};

export const deleteCall = async (callId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/calls/${callId}?token=${token}`);
  return response.data;
};

// Reports
export const getDashboardReport = async (representative = null, startDate = null, endDate = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/reports/dashboard?token=${token}`;
  if (representative && representative !== 'all') {
    url += `&representative=${representative}`;
  }
  if (startDate) {
    url += `&start_date=${startDate}`;
  }
  if (endDate) {
    url += `&end_date=${endDate}`;
  }
  const response = await axios.get(url);
  return response.data;
};

export const getRepDetails = async (rep, type, startDate = null, endDate = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/reports/rep-details?token=${token}&rep=${rep}&type=${type}`;
  if (startDate && endDate) {
    url += `&start_date=${startDate}&end_date=${endDate}`;
  }
  const response = await axios.get(url);
  return response.data;
};

export const getCategoryDetails = async (category, startDate, endDate, representative = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/reports/category-details?token=${token}&category=${encodeURIComponent(category)}`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (representative) url += `&representative=${representative}`;
  const response = await axios.get(url);
  return response.data;
};

export const getUnvisitedCustomers = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/reports/unvisited-customers?token=${token}`);
  return response.data;
};

// File download
export const getFileDownloadUrl = (fileId) => {
  const token = localStorage.getItem('token');
  return `${API_BASE}/files/${fileId}?token=${token}`;
};

export const getFileUrl = (fileId) => {
  const token = localStorage.getItem('token');
  return `${API_BASE}/files/${fileId}?token=${token}`;
};

// Product API
export const getProducts = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/products?token=${token}`);
  return response.data;
};

export const getRepresentativeProducts = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/representative-products?token=${token}`);
  return response.data;
};

export const getProduct = async (productId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/products/${productId}?token=${token}`);
  return response.data;
};

export const createProduct = async (productData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/products?token=${token}`, productData);
  return response.data;
};

export const updateProduct = async (productId, productData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/products/${productId}?token=${token}`, productData);
  return response.data;
};

export const deleteProduct = async (productId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/products/${productId}?token=${token}`);
  return response.data;
};


export const bulkImportProducts = async (productsData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/products/bulk-import?token=${token}`, productsData);
  return response.data;
};



// Targets API
export const getTargets = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/targets?token=${token}`);
  return response.data;
};

// AI Customer Analysis - DEVRE DIŞI
export const analyzeCustomer = async (customerId) => {
  return { 
    error: "AI özellikleri devre dışı bırakıldı",
    analysis: "AI analizi bu projede devre dışı bırakılmıştır."
  };
};

// Product Library API
export const uploadProductLibraryFile = async (file) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('file', file);
  formData.append('token', token);
  
  const response = await axios.post(`${API_BASE}/product-library/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const getProductLibraryFiles = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/product-library?token=${token}`);
  return response.data;
};

export const downloadProductLibraryFile = async (fileId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/product-library/${fileId}/download?token=${token}`, {
    responseType: 'blob'
  });
  return response;
};

export const getProductLibraryFilePreview = (fileId) => {
  const token = localStorage.getItem('token');
  return `${API_BASE}/product-library/${fileId}/preview?token=${token}`;
};

export const deleteProductLibraryFile = async (fileId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/product-library/${fileId}?token=${token}`);
  return response.data;
};


// Offers
export const getOffers = async (customerId = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/offers?token=${token}`;
  if (customerId) {
    url += `&customer_id=${customerId}`;
  }
  const response = await axios.get(url);
  return response.data;
};

export const getOffer = async (offerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/offers/${offerId}?token=${token}`);
  return response.data;
};

export const createOffer = async (offerData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/offers?token=${token}`, offerData);
  return response.data;
};

export const updateOffer = async (offerId, offerData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/offers/${offerId}?token=${token}`, offerData);
  return response.data;
};

export const deleteOffer = async (offerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/offers/${offerId}?token=${token}`);
  return response.data;
};

// Subscription Offers (Abonelik Fiyat Teklifleri)
export const getSubscriptionOffers = async (customerId = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/subscription-offers?token=${token}`;
  if (customerId) {
    url += `&customer_id=${customerId}`;
  }
  const response = await axios.get(url);
  return response.data;
};

export const getSubscriptionOffer = async (offerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE}/subscription-offers/${offerId}?token=${token}`);
  return response.data;
};

export const createSubscriptionOffer = async (offerData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE}/subscription-offers?token=${token}`, offerData);
  return response.data;
};

export const updateSubscriptionOffer = async (offerId, offerData) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE}/subscription-offers/${offerId}?token=${token}`, offerData);
  return response.data;
};

export const deleteSubscriptionOffer = async (offerId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE}/subscription-offers/${offerId}?token=${token}`);
  return response.data;
};

// Reports
export const getProductCompanyProfitReport = async (startDate, endDate, representative = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/reports/product-company-profit?token=${token}`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (representative && representative !== 'all') url += `&representative=${representative}`;
  const response = await axios.get(url);
  return response.data;
};

export const getRepresentativeRevenueReport = async (startDate, endDate) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/reports/representative-revenue?token=${token}`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  const response = await axios.get(url);
  return response.data;
};

// Satış Adet Raporları
export const getSalesQuantityReport = async (startDate = null, endDate = null, representative = null) => {
  const token = localStorage.getItem('token');
  let url = `${API_BASE}/reports/sales-quantity?token=${token}`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (representative && representative !== 'all') url += `&representative=${representative}`;
  const response = await axios.get(url);
  return response.data;
};

